import React from "react";
import { motion } from "framer-motion";
import {
    FaHtml5,
    FaCss3Alt,
    FaBootstrap,
    FaSass,
    FaJs,
    FaReact,
    FaGitAlt,
    FaGithub,
    FaPhp,
    FaLaptopCode,
    FaDatabase,
    FaSearch,
    FaWordpress,
    FaMicrosoft,
  } from "react-icons/fa";
  
  import {
    SiTailwindcss,
    SiPython,
    SiDotnet,
    SiFigma,
    SiAngular,
    SiTypescript,
    SiD3Dotjs,
    SiFirebase,
    SiKotlin,
    SiAndroidstudio,
  } from "react-icons/si";
  
  const skills = [
    { icon: <FaHtml5 />, label: "HTML" },
    { icon: <FaCss3Alt />, label: "CSS" },
    { icon: <FaBootstrap />, label: "Bootstrap" },
    { icon: <FaSass />, label: "SASS" },
    { icon: <SiTailwindcss />, label: "Tailwind" },
    { icon: <FaJs />, label: "JavaScript" },
    { icon: <SiAngular />, label: "Angular" },
    { icon: <FaReact />, label: "React" },
    { icon: <SiPython />, label: "Python" },
    { icon: <FaPhp />, label: "PHP" },
    { icon: <FaGitAlt />, label: "Git" },
    { icon: <FaGithub />, label: "GitHub" },
    { icon: <SiDotnet />, label: ".NET" },
    { icon: <FaLaptopCode />, label: "Full Stack" },
    { icon: <FaDatabase />, label: "Database" },
    { icon: <FaSearch />, label: "SEO" },
    { icon: <FaWordpress />, label: "WordPress" },
    { icon: <SiFigma />, label: "Figma" },
    { icon: <SiTypescript />, label: "TypeScript" },
    { icon: <SiD3Dotjs />, label: "D3.js" },
    { icon: <SiFirebase />, label: "Firebase" },
    { icon: <SiKotlin />, label: "Kotlin" },
    { icon: <SiAndroidstudio />, label: "Android Studio" },
    { icon: <FaMicrosoft />, label: "SQL Server" },
  ];
  
const SkillsSection = () => {
  return (
    <section className="py-20 px-6 md:px-28 bg-transparent text-white text-center">
      <motion.h2
         initial={{ opacity: 0, y: 40 }}
         whileInView={{ opacity: 1, y: 0 }}
         transition={{ duration: 1, ease: "easeOut" }}
         className="text-4xl sm:text-5xl font-extrabold mb-20 leading-tight tracking-wide animate-fadeIn"
       
      >
        Explore My <span className="text-[#55e6a5]">Practical Skills</span>
      </motion.h2>

      <motion.div
        initial="hidden"
        whileInView="show"
        variants={{
          hidden: {},
          show: {
            transition: {
              staggerChildren: 0.1,
            },
          },
        }}
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-10 justify-center items-center"
      >
        {skills.map((skill, i) => (
          <motion.div
          key={i}
          className="flex flex-col items-center text-white hover:text-[#55e6a5] transition-transform duration-300 transform hover:scale-110 animate-float"
          variants={{
            hidden: { opacity: 0, y: 30 },
            show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
          }}
        >
          <div className="text-4xl mb-2 animate-pulseGlow">{skill.icon}</div>
          <span className="text-sm font-medium">{skill.label}</span>
        </motion.div>
        
        ))}
      </motion.div>
    </section>
  );
};

export default SkillsSection;
